import React from "react";
import { useTranslation } from "react-i18next";
import PageShell from "../components/PageShell";
import ProductsSection from "../sections/Products";

const Products = () => {
  const { t } = useTranslation();
  return (
    <PageShell title={t("products.pageTitle")} mainClass="page">
      <ProductsSection />
    </PageShell>
  );
};

export default Products;
